import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../services/loader/loader.service';
/**
 * This is a common component to display a loader on screen. 
 * 
 * To call this loader we use loader service and its methods.
 */
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  isShow = false;
  constructor(private loader: LoaderService) { }

  ngOnInit() {
    this.loader.indicatorLoader.subscribe(state=>{
      this.isShow = state;
    })
  }

}
